(function () {
    'use strict';
    app.controller('discountCodeManagementController', ['$filter', '$scope', '$location', '$cookies', 'progressBarService', '$rootScope', '$timeout', '$routeParams', 'discountCodeManagementService', '$http', function ($filter, $scope, $location, $cookies, progressBarService, $rootScope, $timeout, $routeParams, discountCodeManagementService, $http) {

        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined || getLocalValue('userRole') != 'SAdmin') {
            $location.path('/login');
            return false;
        }
        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;

        $scope.discountCodeModel = function () {
            $scope.discountData = {
                code: '',
                codeName: '',
                individual: true,
                team: true,
                startDate: '',
                endDate: '',
                maxOfUses: '',
                percentValue: '',
                dollarValue: ''
            }
        };
        $scope.discountCodeModel();

        $scope.reloadDatePicker = function () {
            $('.daterangepickerInp').daterangepicker({
                singleDatePicker: true,
                showDropdowns: true,
                minDate: new Date(),
                locale: {
                    format: 'MM-DD-YYYY'
                }
            });
        }
        $scope.reloadDatePicker();

        $scope.displayCreateDiscountModal = function () {
            $scope.discountCodeModel();
            $scope.modalMessage = '';
            $scope.isModalSuccess = false;
            $scope.isModalError = false;
            $scope.dateErrMsg = "";
            $scope.dateErr = false;
            $scope.discountCodeForm.$setPristine();
            $scope.discountCodeForm.$setUntouched();
            $('#createDiscountCodeModal').modal({ backdrop: 'static', keyboard: false })
            $('#createDiscountCodeModal').modal('show');
        }

        $scope.createDiscountCode = function () {
            if ($scope.checkDiscountCodeDetails('create')) {
                progressBarService.showProgressBar();
                var data = {
                    eSpectraDiscountCode: $scope.discountData.code,
                    eSpectraDiscountName: $scope.discountData.codeName,
                    eSpectraDiscountValue: $scope.discountData.percentValue == '' ? $scope.discountData.dollarValue : $scope.discountData.percentValue,
                    eSpectraValueType: $scope.discountData.percentValue != '' ? 'percent' : 'money',
                    eSpectraEffectiveStartDate: $scope.discountData.startDate,
                    eSpectraEffectiveEndDate: $scope.discountData.endDate,
                    eSpectraMaxUseCount: $scope.discountData.maxOfUses,
                    eSpectraSubTypeIndividual: $scope.discountData.individual ? 'ePrem' : '',
                    eSpectraSubTypeTeam: $scope.discountData.team ? 'eTeam' : '',
                }

                discountCodeManagementService.createDiscountCode(data).then(function (response) {
                    if (response != null && response.data.message != undefined) {
                        $scope.modalMessage = response.data.message;
                        $scope.isModalError = true;
                        $scope.isModalSuccess = false;
                        progressBarService.hideProgressBar();
                    }
                    else {
                        $scope.modalMessage = GetMessage.discountCodeCreatedSuccessfully;
                        $scope.isModalError = false;
                        $scope.isModalSuccess = true;
                        $scope.discountCodeForm.$setPristine();
                        $scope.discountCodeForm.$setUntouched();
                        $scope.discountCodeModel();
                        progressBarService.hideProgressBar();
                        $scope.getDiscountCodes();
                    }
                });
            }
        }

        $scope.checkDiscountCodeDetails = function (action) {
            if (action == 'create') {
                if ($scope.discountData.code != "" && $scope.discountData.codeName != "" && $scope.discountData.code != undefined && $scope.discountData.codeName != undefined && ($scope.discountData.dollarValue != "" || $scope.discountData.percentValue != "") && $scope.discountData.startDate != "" && $scope.discountData.endDate != "" && $scope.discountData.maxOfUses != "" && ($scope.discountData.individual || $scope.discountData.team)) {
                    return true;
                }
            } else {
                if ($scope.editDiscountData.eSpectraDiscountCode != "" && $scope.editDiscountData.eSpectraDiscountCode != undefined && $scope.editDiscountData.eSpectraDiscountName != "" && $scope.editDiscountData.eSpectraDiscountName != undefined && ($scope.editDiscountData.eSpectraMoneyValue != "" || $scope.editDiscountData.eSpectraPercentValue != "") && $scope.editDiscountData.eSpectraEffectiveStartDate != "" && $scope.editDiscountData.eSpectraEffectiveEndDate != "" && $scope.editDiscountData.eSpectraMaxUseCount != "" && ($scope.editDiscountData.eSpectraSubTypeIndividual || $scope.editDiscountData.eSpectraSubTypeTeam)) {
                    return true;
                }
            }
            return false;
        }

        $scope.reset = function () {
            $scope.isAccordionHide = true;
            $scope.discountCodes = [];

            $scope.pagination = {
                currentPage: 1,
                itemsPerPage: 10,
                totalRows: 0,
                sortBy: 'eSpectraDiscountCode',
                reverse: false
            }

            $scope.search = {
                discountCode: '',
                discountCodeName: '',
                active: true,
                inactive: true,
            }
        }
        $scope.reset();

        $scope.getDiscountCodes = function (click) {
            progressBarService.showProgressBar();
            if (click == "search") {
                $scope.discountCodes = [];
                $scope.pagination.currentPage = 1;
                $scope.pagination.sortBy = 'eSpectraDiscountCode';
                $scope.pagination.reverse = false;
            }

            var data = {
                eSpectraDiscountCode: $scope.search.discountCode,
                eSpectraDiscountName: $scope.search.discountCodeName,
                Active: $scope.search.active ? 'active' : '0',
                Inactive: $scope.search.inactive ? 'deactivated' : '0',
                PageNo: $scope.pagination.currentPage,
                SortBy: $scope.pagination.sortBy,
                Reverse: $scope.pagination.reverse ? 'desc' : 'asc',
            }

            discountCodeManagementService.getDiscountCodes(data).then(function (response) {
                $scope.isAccordionHide = false;
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.discountCodes = response.data;
                    if ($scope.discountCodes.length > 0) {
                        $scope.pagination.totalRows = $scope.discountCodes[0].totalNumberOfRecords;
                    }
                }
                progressBarService.hideProgressBar();
            });
        };

        $scope.sortCodes = function (sortBy) {
            if ($scope.discountCodes.length > 0) {
                $scope.pagination.sortBy = sortBy;
                $scope.pagination.currentPage = 1;
                $scope.pagination.reverse = !$scope.pagination.reverse;
                $scope.getDiscountCodes();
            }
        }

        $scope.setPage = function (currentPage) {
            $scope.pagination.currentPage = currentPage;
            $scope.getDiscountCodes();
        }

        $scope.exportDiscountCodesReport = function () {
            progressBarService.showProgressBar();
            $scope.getCurrentDate();
            var data = {
                eSpectraDiscountCode: $scope.search.discountCode,
                eSpectraDiscountName: $scope.search.discountCodeName,
                Active: $scope.search.active ? 'active' : '0',
                Inactive: $scope.search.inactive ? 'deactivated' : '0',
                PageNo: $scope.pagination.currentPage,
                SortBy: $scope.pagination.sortBy,
                Reverse: $scope.pagination.reverse ? 'desc' : 'asc',
            }

            discountCodeManagementService.getDiscountCodesReport(data).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    var csv = convertArrayOfObjectsToCSV({
                        data: response.data
                    });

                    BlobDownloadCSV('DiscountCodeManagementReport_' + $scope.currentDate + '.csv', csv)
                }

                progressBarService.hideProgressBar();
            });
        }

        $scope.getCurrentDate = function () {
            var today, dd, mm, yyyy, currentDate, startDate, endDate, parameter;
            today = new Date();
            dd = today.getDate();
            mm = today.getMonth() + 1; //January is 0!

            yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            $scope.currentDate = mm + '/' + dd + '/' + yyyy;
        }

        function convertArrayOfObjectsToCSV(args) {

            var result, ctr, keys, columnDelimiter, lineDelimiter, data, headers;

            data = args.data || null;
            if (data == null || !data.length) {
                return null;
            }

            columnDelimiter = args.columnDelimiter || ',';
            lineDelimiter = args.lineDelimiter || '\n';


            keys = Object.keys(data[0]).slice(1);

            headers = ["Code",
                    "Name",
                    "Percentage",
                    "Dollars",
                    "Individual/Team",
                    "Start Date",
                    "End Date",
                    "Max # of uses",
                    "Total Uses"]

            result = 'Report Name' + columnDelimiter + "Discount Code Management Report" + lineDelimiter;
            result += headers.join(columnDelimiter);
            result += lineDelimiter;

            data.forEach(function (item) {

                ctr = 0;
                keys.forEach(function (key) {
                    if (ctr > 0) result += columnDelimiter;

                    result += item[key];
                    ctr++;
                });
                result += lineDelimiter;
            });

            return result;
        }

        $scope.reloadEditDatePicker = function (startdate, enddate, mindate) {
            $('.editstartdaterangepickerInp').daterangepicker({
                singleDatePicker: true,
                showDropdowns: true,
                startDate: startdate,
                endDate: startdate,
                minDate: mindate,
                locale: {
                    format: 'MM-DD-YYYY'
                }
            });
            $('.editenddaterangepickerInp').daterangepicker({
                singleDatePicker: true,
                showDropdowns: true,
                startDate: enddate,
                endDate: enddate,
                minDate: startdate,
                locale: {
                    format: 'MM-DD-YYYY'
                }
            });
        }

        $scope.displayEditDiscountModal = function (discountCode) {
            progressBarService.showProgressBar();
            $scope.getCurrentDate();
            $scope.dateErrMsg = "";
            $scope.dateErr = false;
            $scope.editModalMessage = "";
            $scope.isEditModalError = false;
            $scope.isEditModalSuccess = false;
            discountCodeManagementService.getDiscountData(discountCode).then(function (response) {
                $scope.isAccordionHide = false;
                if (response != null && response.data.message != undefined) {
                    $scope.editModalMessage = response.data.message;
                    $scope.isEditModalError = true;
                    $scope.isEditModalSuccess = false;
                }
                else {
                    $scope.editDiscountData = response.data;
                    $scope.editDiscountData.eSpectraProdDiscountIDs = $scope.editDiscountData.eSpectraProdDiscountIDs.trim()
                    $scope.editDiscountData.eSpectraEffectiveEndDate = $filter('date')($scope.editDiscountData.eSpectraEffectiveEndDate, "MM-dd-yyyy");
                    $scope.editDiscountData.eSpectraEffectiveStartDate = $filter('date')($scope.editDiscountData.eSpectraEffectiveStartDate, "MM-dd-yyyy");
                    $scope.editDiscountData.eSpectraSubTypeIndividual = $scope.editDiscountData.eSpectraSubscriptionType.toLowerCase() == 'individual' || $scope.editDiscountData.eSpectraSubscriptionType.toLowerCase() == 'both' ? true : false;
                    $scope.editDiscountData.eSpectraSubTypeTeam = $scope.editDiscountData.eSpectraSubscriptionType.toLowerCase() == 'team' || $scope.editDiscountData.eSpectraSubscriptionType.toLowerCase() == 'both' ? true : false;

                    $scope.editDiscountDataBackup = angular.copy($scope.editDiscountData);
                    var currentDate = $scope.currentDate.replace((new RegExp('/', 'g')), '-');

                    var minDate = new Date (GetDate(currentDate)) > new Date(GetDate($scope.editDiscountData.eSpectraEffectiveStartDate)) ? $scope.editDiscountData.eSpectraEffectiveStartDate : currentDate;
                    $scope.reloadEditDatePicker($scope.editDiscountData.eSpectraEffectiveStartDate, $scope.editDiscountData.eSpectraEffectiveEndDate, minDate);

                    $('#editDiscountCodeModal').modal({ backdrop: 'static', keyboard: false })
                    $('#editDiscountCodeModal').modal('show');
                }
                progressBarService.hideProgressBar();
            });
        }

        $scope.updateDiscountCode = function () {
            if ($scope.checkDiscountCodeDetails('update')) {
                progressBarService.showProgressBar();
                var tempDiscountCode = angular.copy($scope.editDiscountData);
                if (angular.equals($scope.editDiscountDataBackup, tempDiscountCode)) {
                    progressBarService.hideProgressBar();
                    $('#editDiscountCodeModal').modal('hide');
                } else {
                    var data = {
                        eSpectraProdDiscountIDs: $scope.editDiscountData.eSpectraProdDiscountIDs,
                        eSpectraDiscountCode: $scope.editDiscountData.eSpectraDiscountCode,
                        eSpectraDiscountName: $scope.editDiscountData.eSpectraDiscountName,
                        eSpectraDiscountValue: $scope.editDiscountData.eSpectraPercentValue == '' ? $scope.editDiscountData.eSpectraMoneyValue : $scope.editDiscountData.eSpectraPercentValue,
                        eSpectraValueType: $scope.editDiscountData.eSpectraPercentValue != '' ? 'percent' : 'money',
                        eSpectraEffectiveStartDate: $scope.editDiscountData.eSpectraEffectiveStartDate,
                        eSpectraEffectiveEndDate: $scope.editDiscountData.eSpectraEffectiveEndDate,
                        eSpectraMaxUseCount: $scope.editDiscountData.eSpectraMaxUseCount,
                        eSpectraSubTypeIndividual: $scope.editDiscountData.eSpectraSubTypeIndividual ? 'ePrem' : '',
                        eSpectraSubTypeTeam: $scope.editDiscountData.eSpectraSubTypeTeam ? 'eTeam' : '',
                    }
                    discountCodeManagementService.updateDiscountCode(data).then(function (response) {
                        $scope.isAccordionHide = false;
                        if (response != null && response.data.message != undefined) {
                            $scope.editModalMessage = response.data.message;
                            $scope.isEditModalError = true;
                            $scope.isEditModalSuccess = false;
                        }
                        else {
                            $scope.message = GetMessage.discountCodeEditedSuccessfully(data.eSpectraDiscountCode);
                            $scope.isError = false;
                            $scope.isSuccess = true;
                            $scope.getDiscountCodes();
                            $('#editDiscountCodeModal').modal('hide');
                        }
                        progressBarService.hideProgressBar();
                    });
                }
            }

        }

        $scope.confirmDelete = function (discountCode) {
            $scope.discountCode = discountCode;
            $scope.isError = false;
            $scope.isSuccess = false;
            $scope.message = '';
            $("#confirmDelete").modal('toggle');
            $("#data-del-no-btn").focus();
        }

        $scope.deleteDiscountCode = function () {
            $("#confirmDelete").modal('toggle');
            progressBarService.showProgressBar();
            var data = {
                eSpectraDiscountCode: $scope.discountCode.eSpectraDiscountCode
            }
            discountCodeManagementService.deleteDiscountCode(data).then(function (response) {
                if (response != null && response.data.message != undefined) {
                    $scope.message = response.data.message;
                    $scope.isError = true;
                    $scope.isSuccess = false;
                }
                else {
                    $scope.isError = false;
                    $scope.isSuccess = true;
                    $scope.message = GetMessage.discountCodeDeletedSuccessfully($scope.discountCode.eSpectraDiscountCode);
                    $scope.getDiscountCodes();
                }
                progressBarService.hideProgressBar();
            });

        }

        $scope.checkDates = function (startDate, endDate) {
            startDate = new Date(GetDate(startDate))
            endDate = new Date(GetDate(endDate))

            if (startDate != '' && endDate != '') {
                if (startDate > endDate) {
                    $scope.dateErrMsg = "Please select valid end date.";
                    $scope.dateErr = true
                } else {
                    $scope.dateErrMsg = "";
                    $scope.dateErr = false;
                }
            }
        }

        function GetDate(date) {
            var dateArray = [], i = 0, from = 0, year, month, day;
            while (date.length > 0) {
                if (date.indexOf('-') > 0) {
                    dateArray[i] = date.substring(0, date.indexOf('-'));
                } else {
                    dateArray[i] = date.substring(0, date.length);
                }
                from = dateArray[i].length + 1;
                date = date.substr(from, date.length)
                i++;
            }

            month = dateArray[0];
            day = dateArray[1];
            year = dateArray[2];

            return year + "-" + month + "-" + day;
        }
    }]);
})();